
import { Card, CardContent } from "@/components/ui/card";

const testimonials = [
  {
    name: "Ana C.",
    text: "As consultas online facilitaram muito minha vida. Consigo fazer terapia mesmo com minha agenda lotada. A plataforma é muito intuitiva!",
    rating: 5,
    image: "https://randomuser.me/api/portraits/women/79.jpg"
  },
  {
    name: "Carlos M.",
    text: "Estava receoso com terapia online, mas a experiência superou minhas expectativas. Sinto-me tão acolhido quanto em sessões presenciais.",
    rating: 5,
    image: "https://randomuser.me/api/portraits/men/54.jpg"
  },
  {
    name: "Patricia S.",
    text: "O agendamento é super prático e os preços são justos. Recomendo para quem busca praticidade sem abrir mão de um atendimento de qualidade.",
    rating: 4,
    image: "https://randomuser.me/api/portraits/women/45.jpg"
  }
];

const Testimonials = () => {
  return (
    <section className="space-y-8">
      <div className="text-center max-w-xl mx-auto space-y-2">
        <h2 className="text-3xl font-bold">O que dizem nossos pacientes</h2>
        <p className="text-muted-foreground">
          Experiências reais de pessoas que transformaram suas vidas
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {testimonials.map((testimonial, i) => (
          <Card key={i} className="card-hover">
            <CardContent className="p-6 space-y-4">
              <div className="flex items-center gap-3">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="font-medium">{testimonial.name}</p>
                  <div className="flex">
                    {Array(5).fill(0).map((_, i) => (
                      <svg 
                        key={i} 
                        className={`w-4 h-4 ${i < testimonial.rating ? "text-yellow-400" : "text-gray-300"}`}
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-muted-foreground">"{testimonial.text}"</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
